import { Component, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import NavigationPager from "../../components/navigation-pager/NavigationPager.vue";
import { NavbarBus } from "../index";

import "animate.css";

@Component({
    name: "ModalView",
    components: {
        "navigation-pager": NavigationPager
    }
})
export default class ModalView extends Vue {
    private static ID = 0;

    @Prop() modalId!: string;
    @Prop() value!: boolean;
    @Prop({type: Boolean}) fullFlowLayout!: boolean;

    private changingHash = false;
    private navigationPagerHeight = 46;

    @Watch("value")
    valueChange(newValue: boolean) {
        if (newValue) {
            this.showModal();
        } else {
            this.closeModal();
        }
    }

    @Provide("closeCurrentView")
    closeCurrentView() {
        this.$emit("input", false);
    }

    private showModal() {
        const pages = this.getPages();
        pages.push(this.id);
        this.setHash(pages);
    }

    private closeModal() {
        const pages = this.getPages();
        if (pages.length === 0) {
            return;
        }

        pages.pop();
        this.setHash(pages);
        this.$emit("close-current-view");
    }

    private setHash(pages: string[]) {
        this.changingHash = true;
        window.location.hash = pages.join(";");
    }

    private onHashChangeHandler() {
        if (this.changingHash) {
            this.changingHash = false;
            return;
        }

        if (!this.value) {
            return;
        }

        // Removes first hash char '#'
        const pageNames = this.getPages();
        const found = !!pageNames.find(el => el === this.id);
        if (!found) {
            this.closeModal();
        }
    }

    private getPages(): string[] {
        const pages = window.location.hash.slice(1).split(";");
        return pages || [];
    }

    private currentModalProgressive = ++ModalView.ID;
    private zIndex!: number;

    public get id(): string {
        return `${this.modalId || "page"}-${this.currentModalProgressive}`;
    }

    mounted() {
        this.zIndex = 500 + this.getPages().length * 10;
        window.addEventListener("hashchange", this.onHashChangeHandler, false);
    }

    private setPagerHeight(e: number){
        this.navigationPagerHeight = e;
    }

    private get modalContentStyle() {
        if(this.fullFlowLayout){
            return {
                "max-height": "calc(100% - " + this.navigationPagerHeight + "px)",
            }
        } else {
            return {};
        }
    }

    destroyed() {
        window.removeEventListener("hashchange", this.onHashChangeHandler, false);
    }

}
